<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [subheader]="data.p1" [separator]="false" />
    <email-margin [height]="36" />
  </ng-container>

  <ng-container body>
    <email-candidates-reports [reports]="data.offers" [headerLinkLabel]="data.offer_link_text" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer_p1" color="light" presetName="inline" size="small" /><br />
    <email-link
      [label]="data.footer_link_text"
      [href]="data.footer_link"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
